<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>{{title}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickCancel"
                >
                    Cancel
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                style="margin-bottom: 15px;"
                v-on:input="update()"
                autofocus
                @keydown.enter="$event.preventDefault(); signInAsFirstResult();"
                autocomplete="off"
            />

            <v-data-table
                :headers="headers"
                :items="results"
                :items-per-page="100"
                class="elevation-1"
                hide-default-footer
                @click:row="signInAs"
            >
                <template v-slot:item.is_system_admin="{ item }">
                    <v-simple-checkbox v-model="item.is_system_admin" disabled></v-simple-checkbox>
                </template>

                <template v-slot:item.is_organization_admin="{ item }">
                    <v-simple-checkbox v-model="item.is_organization_admin" disabled></v-simple-checkbox>
                </template>

                <template v-slot:item.is_archived="{ item }">
                    <v-simple-checkbox v-model="item.is_archived" disabled></v-simple-checkbox>
                </template>

                <template v-slot:item.is_organization_archived="{ item }">
                    <v-simple-checkbox v-model="item.is_organization_archived" disabled></v-simple-checkbox>
                </template>

                <template v-slot:item.has_set_password="{ item }">
                    <v-simple-checkbox v-model="item.has_set_password" disabled></v-simple-checkbox>
                </template>



            </v-data-table>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            organization: null,
            search: null,

            results: [],

            headers: [
                { text: 'Username', value: 'username' },
                { text: 'Name', value: 'employee_label' },
                { text: 'Organization', value: 'organization_label' },
                { text: 'System Admin', value: 'is_system_admin' },
                { text: 'Organization Admin', value: 'is_organization_admin' },
                { text: 'Archived', value: 'is_archived' },
                { text: 'Has Password', value: 'has_set_password' },
            ],
        }
    },

    methods: {

        showDialog(organization)
        {
            this.organization = organization;
            this.search = null;
            this.doUpdate();

            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;

        },

         update: _.debounce(function(){
            this.doUpdate();
        }, 751),

        doUpdate()
        {
            this.$rc.rest(
                'LIST: /api/v1/admin/search-employees',

                {
                    'full_text' : this.search,
                    'organization_id' : this.organization.organization_id,
                },

                (data) => {
                    this.results = data.results;
                },

                () => {
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }

            // data is valid, so save
            this.dialog = false;
            next(false);
        },

        onClickCancel()
        {
            this.closeDialog();
        },

        signInAsFirstResult()
        {
            if ( this.results == null || this.results.length == 0 )
                return;

            this.signInAs(this.results[0]);
        },

        signInAs(item)
        {
            if ( item.is_archived && !this.$rc.$state.isAuthActorSystemAdmin() )
            {
                this.$rc.alert('Unable to sign in as', 'You may not sign in as an archived user');
                return;
            }

            this.closeDialog();

            this.$rc.newSignInAs(
                {
                    'organization_id': item.organization_id,
                    'employee_id': item.employee_id,
                }
            );
        }

    },

    computed: {
        title() {
            if ( this.organization == null )
                return 'Sign In As...';

            return "Sign in as: "+this.organization.label;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>